
import Vue from  'vue'
import eventHub from '../../mixins/eventHub'

export default {

    props: {

		state: {
            type: String,
            default: ''
        },

		args:  {
            type: Array,
            default: function()
            {
                return args;
            }
        }
    },

	methods: {

		onEmit()
        {
			this.eventHub.$emit(this.state, this.args);
		}
	}
}
